import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import '../styles/demo.css';

const Demo = () => {
    const [selectedParty, setSelectedParty] = useState(null);

    const partyData = [
        {
            id: 1,
            title: 'L\'architecture intérieure révélée.',
            shortText: 'Il existe une intelligence du corps que peu savent lire. Une mémoire silencieuse inscrite dans chaque posture...',
            fullText: `Il existe une intelligence du corps que peu savent lire.
Une mémoire silencieuse inscrite dans chaque posture, chaque tension, chaque ligne.

H'ART ÉLÉGANCE est la première Maison dédiée à la lecture de l'Être.
Ici, révéler n'est pas transformer. C'est reconnaître ce qui, en silence, attendait d'être vu.`,
            image: require('../assets/new1.jpg')
        },
        {
            id: 2,
            title: 'Exceller avant de commencer.',
            shortText: 'La véritable élégance n\'est jamais improvisée...',
            fullText: `La véritable élégance n'est jamais improvisée.
Elle naît d'une compréhension profonde de ce qui nous constitue — de notre architecture intérieure, de nos fils émotionnels, de la structure invisible qui gouverne notre présence dans le monde.

H'ART ÉLÉGANCE est une Maison rare.
Elle s'adresse à ceux qui refusent la surface et exigent la profondeur.`,
            image: require('../assets/newer.jpg')
        },
        {
            id: 3,
            title: 'Morphologie Émotionnelle',
            shortText: 'Lire — L\'art de décrypter ce que le corps exprime...', 
            fullText: `Morphologie Émotionnelle — Lire

L'art de décrypter ce que le corps exprime avec précision et profondeur.

Chaque posture, chaque ligne, chaque tension révèle une histoire émotionnelle.
C'est la porte d'entrée de toute révélation chez H'ART ÉLÉGANCE.`,
            image: require('../assets/section3.jpg')
        },
        {
            id: 4,
            title: 'Fils Émotionnels',
            shortText: 'Comprendre — Le métier à tisser des dynamiques intérieures...',
            fullText: `Fils Émotionnels — Comprendre

Le métier à tisser des dynamiques intérieures — chaque émotion, un fil de l'architecture.

Chaque émotion est un fil précieux — soie, velours, lin tendu par la mémoire — qui révèle le tissage subtil entre histoire intérieure et manifestations visibles dans la présence.`,
            image: require('../assets/new2.jpg')
        },
        {
            id: 5,
            title: 'Architecture de l\'Être',
            shortText: 'Révéler — L\'organisation harmonieuse de la présence...',
            fullText: `Architecture de l'Être — Révéler

L'organisation harmonieuse de la présence — cohérence entre posture, expression et essence.

C'est ici que l'être reconnaît sa propre structure — et l'habite pleinement.`,
            image: require('../assets/section5.jpg')
        }
    ];

    const handleDiscover = () => {
        const el = document.querySelector('.manifeste-section');
        if (el) el.scrollIntoView({ behavior: 'smooth' });
    };

    const closePopup = () => {
        setSelectedParty(null);
    };

    useEffect(() => {
        // fallback for browsers that don't support :has() in CSS
        if (selectedParty) {
            document.body.classList.add('modal-open');
        } else {
            document.body.classList.remove('modal-open');
        }
        return () => document.body.classList.remove('modal-open');
    }, [selectedParty]);

    return (
        <div className="demo-page">
            <main>
                    

                <section className="hero">
                    <div className="hero-content">
                        <div className="header-intro-content">
                            <img src={require('../assets/LogoPng.png')} alt="H'ART ÉLÉGANCE" className="hero-logo" aria-hidden="true" />
                            {/* <h1 className="header-title">H'ART ÉLÉGANCE</h1> */}
                            <p className="header-subtitle">Maison de Haute Couture de l'Être</p>
                            <div className="header-decorative-line" />
                            <p className="header-description">L'architecture intérieure révélée</p>
                            <p className="header-motto">Exceller avant de commencer</p>
                        </div>

                        <button className="cta-button" onClick={handleDiscover}>Découvrir</button>
                    </div>

                    <div className="scroll-indicator">
                        <p className="scroll-text">Défiler</p>
                    </div>
                </section>

                <section className="manifeste-section">
                    <div className="manifeste-container">
                        <div className="manifeste-grid">
                            <div className="text-zone">
                            <img src={require('../assets/newer.jpg')} alt="Élégance H'ART ÉLÉGANCE" className="manifeste-image" />

                            <h2 className="main-heading">EXCELLER AVANT DE COMMENCER</h2>
                            
                            <div className="text-content">
                                <p>La véritable élégance n'est jamais improvisée.</p>

                                <p>Elle naît d'une compréhension profonde de ce qui nous constitue — notre architecture intérieure, nos fils émotionnels, la structure invisible qui gouverne notre présence dans le monde.</p>

                                <p>Chez H'ART ÉLÉGANCE, Maison de Haute Couture de l'Être, nous ne créons pas de styles. Nous ne proposons ni coaching, ni thérapie, ni conseil en image.</p>

                                <p>Nous révélons. Nous lisons. Nous reconnaissons.</p>

                                <p className="final-quote">Parce que l'excellence commence avant même de commencer.</p>

                                <div className="decorative-line"></div>
                            </div>

                            <div className="signature">
                                <p className="signature-slogan">RÉVÉLER L'ARCHITECTURE de l'ÊTRE</p>
                                <p className="signature-tagline">H'ART ÉLÉGANCE<br />Maison de Haute Couture de l'Être</p>
                            </div>
                        </div>
                        </div>
                    </div>
                </section>

                <section className="univers-section">
                    <h2 className="univers-title">Explorer La Maison</h2>
                    <p className="univers-subtitle">Trois portes d'accès à l'excellence</p>

                    <div className="univers-grid">
                        <div className="univers-card">
                            <div className="univers-icon">
                                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M19 2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5 18H5V4h9v16zm5 0h-4V4h4v16z" fill="currentColor"/>
                                </svg>
                            </div>
                            <h3>LA MAISON</h3>
                            <p className="card-subtitle">Qui sommes-nous ?</p>
                            <p>Une Maison rare, dédiée à la lecture de l'Être. Nous décryptons l'architecture intérieure de votre présence, ce langage silencieux que votre corps porte en mémoire.</p>
                            <a href="#/about-us" className="card-link">Découvrir</a>
                        </div>

                        <div className="univers-card">
                            <div className="univers-icon">✨</div>
                            <h3>NOS EXPERTISES</h3>
                            <p className="card-subtitle">Morphologie • Émotions • Présence</p>
                            <p>Morphologie Émotionnelle, Fils Émotionnels, Architecture de l'Être, Stylistique, Présence Intemporelle. Cinq disciplines au service de votre révélation.</p>
                            <a href="#/expertises" className="card-link">Découvrir</a>
                        </div>

                        <div className="univers-card">
                            <div className="univers-icon">✨</div>
                            <h3>ENTRER EN RELATION</h3>
                            <p className="card-subtitle">Un échange confidentiel</p>
                            <p>Les rencontres avec la Maison sont sur-mesure, confidentielles et menées avec discernement, confidentialité et justesse. Écrivez-nous pour explorer ensemble.</p>
                            <a href="#/contact" className="card-link">Découvrir</a>
                        </div>
                    </div>
                </section>

                <section className="demo-parties-section">
                    <div className="demo-parties-grid">
                        {partyData.map((party) => (
                            <div key={party.id} className="demo-party-card">
                                <h3>{party.title}</h3>
                                <p>{party.shortText}</p>
                                <button className="party-discover-btn" onClick={() => setSelectedParty(party)}>Découvrir</button>
                            </div>
                        ))}
                    </div>
                </section>

                {selectedParty && (
                    <div className="popup-overlay" onClick={closePopup}>
                        <div className="popup-modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label={selectedParty.title}>
                            <button className="popup-close" onClick={closePopup} aria-label="Fermer">✕</button>
                            <img src={selectedParty.image} alt={selectedParty.title} className="popup-image" />
                            <h2>{selectedParty.title}</h2>
                            <p className="popup-content">{selectedParty.fullText}</p>
                            <div className="popup-actions">
                                <button className="popup-close popup-bottom" onClick={closePopup}>Fermer</button>
                            </div>
                        </div>
                    </div>
                )}

                <section className="contact-section">
                    <div className="contact-container">
                        <h2 className="contact-title">Entrer en Contact avec la Maison</h2>
                        <p className="contact-text">Les rencontres sont confidentielles, sur mesure, et menées avec discernement, confidentialité et justesse.</p>

                        <div className="decorative-line" style={{ margin: '2rem auto' }} />

                        <a href="mailto:contact@hart-elegance.com" className="contact-email">contact@hart-elegance.com</a>

                        <div className="contact-cta">
                            <a href="#/contact" className="cta-button">Demander un entretien confidentiel</a>
                        </div>

                        <div style={{ marginTop: '4rem' }}>
                            <p className="signature-tagline">H'ART ÉLÉGANCE</p>
                            <p style={{ fontSize: '0.9rem', color: 'rgba(212, 175, 55, 0.6)', marginTop: '0.5rem' }}>Haute Couture de l'Être</p>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    );
};

export default Demo;
